module.exports = __webpack_public_path__ + "img/icon-ai-gray.5a3bdbb0.svg";